import { createApi } from '@reduxjs/toolkit/query/react'
import { CONSTANTS } from '../../constants'
import { baseQueryConfigured } from '../../plugins/rtk-query.config'
import {
  Subscriber
} from '../../types'


export const subscribersApi = createApi({
  reducerPath: 'subscribersApi',
  baseQuery: baseQueryConfigured,
  tagTypes: ['Subscribers'],
  endpoints: (builder) => ({
    subscribe: builder.mutation({
      query: (payload: Subscriber) => ({
        url: CONSTANTS.API.SUBSCRIBE,
        method: 'POST',
        body: payload,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      }),
      invalidatesTags: ['Subscribers'],
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useSubscribeMutation,
} = subscribersApi
